import { render, staticRenderFns } from "./GlobalIndicatorsBenificariesProfile.vue?vue&type=template&id=6cec12db&"
import script from "./GlobalIndicatorsBenificariesProfile.vue?vue&type=script&lang=ts&"
export * from "./GlobalIndicatorsBenificariesProfile.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports